(function ($, Drupal, once) {
  Drupal.behaviors.componentShowcaseArticles = {
    attach(context) {

      once('articles-showcase', '.articles-showcase', context).forEach(function (root) {
        const $component = $(root);

        function setActivePetTab($btn) {
          $btn
            .addClass('button-primary')
            .removeClass('button-secondary')
            .attr({ 'aria-selected': 'true', tabindex: '0' })
            .siblings()
            .removeClass('button-primary')
            .addClass('button-secondary')
            .attr({ 'aria-selected': 'false', tabindex: '-1' });
        }

        function initPanelSlider($panel) {
          const $slider = $panel.find('.articles-showcase__panel').first();
          if (!$slider.length || $slider.hasClass('slick-initialized')) {
            return;
          }

          let $controls = $panel.children('.articles-slider-controls');
          if (!$controls.length) {
            $controls = $('<div class="articles-slider-controls">').appendTo($panel);
          } else if ($controls.children().length) return;

          const dlArrow = 'data-datalayer-event="content_events" data-datalayer-parameter_action="arrow"';

          $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 3000,
            variableWidth: true,
            centerMode: false,
            mobileFirst: true,
            adaptiveHeight: false,
            focusOnSelect: false,
            dots: true,
            arrows: true,
            prevArrow: '<button '+dlArrow+' type="button" class="slick-arrow slick-prev" aria-label="Previous"><span aria-hidden="true"></span></button>',
            nextArrow: '<button '+dlArrow+' type="button" class="slick-arrow slick-next" aria-label="Next"><span aria-hidden="true"></span></button>',
            appendArrows: $controls,
            appendDots: $controls,
            slide: ':not(.hidden)',
            responsive: [
              {
                breakpoint: 991,
                settings: {
                  centerMode: false,
                  slidesToShow: 3,
                }
              }
            ]
          });

          $component.find(".slick-dots").attr({"data-datalayer-event": "content_events", "data-datalayer-parameter_action": "dots"});
          $slider.removeClass('set_height');
        }

        const $initialPanel =
          $component.find('.articles-panels > div.is-active:visible').first().length
            ? $component.find('.articles-panels > div.is-active:visible').first()
            : $component.find('.articles-panels > div:visible').first();

        if ($initialPanel.length) {
          initPanelSlider($initialPanel);
        }

        $component.find('.articles-tabs button').on('click', function (e) {
          e.preventDefault();
          const $btn = $(this);
          const petType = $btn.attr('id').replace('articles-tab-', '').toLowerCase();

          setActivePetTab($btn);

          const $panels = $component.find('.articles-panels > div');
          $panels.hide().removeClass('is-active');

          const $target = $component.find('.articles-panel-' + petType);
          $target.show().addClass('is-active');

          initPanelSlider($target);

          const $slider = $target.find('.articles-showcase__panel.slick-initialized');
          if ($slider.length) {
            $slider.slick('setPosition');
          }
        });
      });
    }
  };
})(jQuery, Drupal, once);
